import { toEDNStringFromSimpleObject } from "edn-data";
import { queryOmegaSingleResult } from "../api";
import { LogStream } from "../types/logStream";

export const getLogStream: (config: {
  "log-stream-id": string;
}) => Promise<LogStream> = async (config) => {
  const ednString = toEDNStringFromSimpleObject(config as any, {
    keysAs: "string",
  });
  const query = `
(datastore Qo.Public.Api.LogStream "omega/query-omega/public/api/log-stream")
(Qo.Public.Api.LogStream/get-log-stream ${ednString} Response)
(return [Response])
          `;
  const response = await queryOmegaSingleResult(query);
  return response;
};
